import { FIELDS, } from "./fields.js";
import { BRAND_META_KEYS, } from "./config.js";
export const PATH_BY_KEY = Object.freeze(Object.fromEntries(FIELDS.map((f) => [f.key, f.path])));
const KEY_BY_PATH = Object.fromEntries(FIELDS.map((f) => [f.path, f.key]));
const PASSTHROUGH = new Set(BRAND_META_KEYS);
const HEADER = ["$schema", "schemaVersion", "colorScheme"];
function nestFields(flat) {
    const out = {};
    for (const f of FIELDS) {
        const value = flat[f.key];
        if (value == null)
            continue;
        const dot = f.path.indexOf(".");
        if (dot < 0) {
            out[f.path] = value;
        }
        else {
            const group = f.path.slice(0, dot);
            const leaf = f.path.slice(dot + 1);
            const target = out[group] ?? {};
            target[leaf] = value;
            out[group] = target;
        }
    }
    return out;
}
function flattenFields(input) {
    const out = {};
    for (const [name, value] of Object.entries(input)) {
        if (PASSTHROUGH.has(name) || name === "dark")
            continue;
        if (value != null && typeof value === "object" && !Array.isArray(value)) {
            for (const [leaf, v] of Object.entries(value)) {
                const key = KEY_BY_PATH[`${name}.${leaf}`];
                if (key)
                    out[key] = v;
            }
            continue;
        }
        // A flat key or an ungrouped path (the same string). Unknown keys stay for validation.
        out[KEY_BY_PATH[name] ?? name] = value;
    }
    return out;
}
export function nestBrandConfig(config) {
    const c = config;
    const out = {};
    for (const name of HEADER)
        if (c[name] != null)
            out[name] = c[name];
    Object.assign(out, nestFields(c));
    if (c.fontFaces != null)
        out.fontFaces = c.fontFaces;
    if (c.dark && typeof c.dark === "object") {
        const dark = nestFields(c.dark);
        if (Object.keys(dark).length)
            out.dark = dark;
    }
    return out;
}
export function flattenBrandJson(input) {
    if (!input || typeof input !== "object" || Array.isArray(input))
        return {};
    const doc = input;
    const out = flattenFields(doc);
    for (const name of PASSTHROUGH)
        if (doc[name] != null)
            out[name] = doc[name];
    if (doc.dark && typeof doc.dark === "object" && !Array.isArray(doc.dark)) {
        out.dark = flattenFields(doc.dark);
    }
    return out;
}
